export default [
  {
    text: 'Report Date',
    value: 'report_date',
    width: '110px',
  },
  {
    text: 'Ad Name',
    value: 'ad',
    width: '280px',
    tooltip: 'CPMReportsTableAd',
  },
  {
    text: 'Start Date',
    value: 'start_date',
    width: '100px',
  },
  {
    text: 'End Date',
    value: 'end_date',
    width: '100px',
  },
  {
    text: 'Country',
    value: 'country',
    width: '80px',
  },
  {
    text: 'Paid Impressions',
    value: 'impressions',
    align: 'end',
    width: '150px',
    tooltip: 'CPMReportsTableImpressions',
    // }, {
    //   text: 'Total Clickouts',
    //   value: 'total_clickouts',
    //   align: 'end',
    //   width: '140px',
    //   tooltip: 'CPMReportsTableTotalClickouts',
    // }, {
    //   text: 'Organic Clickouts',
    //   value: 'organic_clickouts',
    //   align: 'end',
    //   width: '150px',
    //   tooltip: 'CPMReportsTableOrganicClickouts',
  },
  {
    text: 'Paid Clickouts',
    value: 'paid_clickouts',
    align: 'end',
    width: '131px',
    tooltip: 'CPMReportsTablePaidClickouts',
    // }, {
    //   text: 'Clickouts Boost',
    //   value: 'clickout_boost',
    //   align: 'end',
    //   width: '140px',
    //   tooltip: 'CPMReportsTableClickoutsBoost',
    // }, {
    //   text: 'Total Deal visits',
    //   value: 'total_deal_visits',
    //   align: 'end',
    //   width: '144px',
    //   tooltip: 'CPMReportsTableTotalDealVisits',
    // }, {
    //   text: 'Organic Deal Visits',
    //   value: 'organic_deal_visits',
    //   align: 'end',
    //   width: '158px',
    //   tooltip: 'CPMReportsTableOrganicDealVisits',
  },
  {
    text: 'Paid Deal Visits',
    value: 'paid_deal_visits',
    align: 'end',
    width: '138px',
    tooltip: 'CPMReportsTablePaidDealVisits',
    // }, {
    //   text: 'Deal Visit Boost',
    //   value: 'deal_visit_boost',
    //   align: 'end',
    //   width: '150px',
    //   tooltip: 'CPMReportsTableDealVisitsBoost',
  },
  {
    text: 'CTR',
    value: 'click_through_rate',
    align: 'end',
    width: '120px',
    tooltip: 'CPMReportsTableCTR',
  },
  {
    text: 'CPM Rate',
    value: 'rate',
    align: 'end',
    width: '120px',
  },
  {
    text: 'Commission CPM',
    value: 'commission',
    align: 'end',
    width: '160px',
    tooltip: 'CPMReportsTableCommission',
  },
];
